// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__27hup","primary":"Button_primary__J2lhM","back":"Button_back__u1zCt","position":"Button_position__ooLVw"};